import React from 'react';
import { useLoading } from '../contexts/LoadingContext';
import './css/LoadingBar.css';

const LoadingBar = () => {
  const { isLoading, progress, message } = useLoading();
  
  if (!isLoading) return null;

  return (
    <div className="loading-bar-overlay">
      <div className="loading-bar-container">
        <div className="loading-bar-track">
          <div 
            className="loading-bar-fill"
            style={{ 
              width: progress ? `${progress}%` : '100%',
              animationDuration: progress ? 'none' : '2s'
            }}
          ></div>
        </div>
        {message && (
          <div className="loading-bar-message">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingBar; 